import { TranslatePipe } from '../../shared/translate/pipes/translate.pipe';
import { DefinitionView } from '../models/observation-definition.model';
import { IReference, IObservationDefinition, IAuditEvent_Detail } from '@ahryman40k/ts-fhir-types/lib/R4';

const OPERATION_NAMES = {
    Count: 'COUNT',
    Avg: 'AVERAGE',
    Std: 'SCATTER',
};

function translateUnit(unit: string, translatePipe: TranslatePipe): string {
    return translatePipe.transform(unit.toUpperCase()) === unit.toUpperCase() ?
        unit : translatePipe.transform(unit.toUpperCase());
}

export function stringToDefinitionView(inData: IReference[], translatePipe: TranslatePipe): DefinitionView {
    const definitionView: DefinitionView = { custom: [], timeSeries: [] };

    if (inData && inData[0]) {
        inData.map(data => {
            const split = data.display.split(';');
            if (split[0] === 'atomic') {
                definitionView.custom.push({
                    values: [
                        translatePipe.transform(split[1].toUpperCase()),
                        split[2] + ' ' + translateUnit(split[3], translatePipe),
                        (split[4] ? split[4] + ' ' + translateUnit(split[5], translatePipe) : undefined)
                    ],
                    reference: data.reference
                });
            } else if (split[0] === 'aggregated') {
                definitionView.timeSeries.push({
                    values: [
                        translatePipe.transform(split[1].toUpperCase()),
                        split[2] + ' ' + translatePipe.transform(split[3].toUpperCase()),
                        translatePipe.transform(OPERATION_NAMES[split[4]]), split[5] + ' ' + split[6]
                    ],
                    reference: data.reference
                });
            }
        });
    }
    return definitionView;
}

export function dataToAtomicAuditEventDetail(oldData: IObservationDefinition, newData: IObservationDefinition): IAuditEvent_Detail[] {
    return [{
        type: 'old',
        valueString: oldData ?
            oldData.method.text + ';' + oldData.qualifiedInterval[0].context.text + ';' +
            oldData.qualifiedInterval[0].range.low.value + ';' + oldData.qualifiedInterval[0].range.low.unit +
            (oldData.qualifiedInterval[0].range.high ? ';' + oldData.qualifiedInterval[0].range.high.value + ';' +
                oldData.qualifiedInterval[0].range.high.unit : '') : ''
    }, {
        type: 'new',
        valueString: newData.method.text + ';' + newData.qualifiedInterval[0].context.text + ';' +
            newData.qualifiedInterval[0].range.low.value + ';' + newData.qualifiedInterval[0].range.low.unit +
            (newData.qualifiedInterval[0].range.high ? ';' + newData.qualifiedInterval[0].range.high.value + ';' +
                newData.qualifiedInterval[0].range.high.unit : '')
    }];
}

export function dataToAggregatedAuditEventDetail(oldData: IObservationDefinition, newData: IObservationDefinition): IAuditEvent_Detail[] {
    return [{
        type: 'old',
        valueString: oldData ?
            oldData.method.text + ';' + oldData.qualifiedInterval[0].context.text + ';' +
            (oldData.qualifiedInterval[0].range.low ?
                oldData.qualifiedInterval[1].range.low.value + ';' +
                oldData.qualifiedInterval[1].range.low.unit + ';' +
                oldData.qualifiedInterval[0].range.low.unit + ';' +
                oldData.qualifiedInterval[0].range.low.value + ';' + 'minimum' :
                oldData.qualifiedInterval[1].range.high.value + ';' +
                oldData.qualifiedInterval[1].range.high.unit + ';' +
                oldData.qualifiedInterval[0].range.high.unit + ';' +
                oldData.qualifiedInterval[0].range.high.value + ';' + 'maximum') : ''
    }, {
        type: 'new',
        valueString: newData.method.text + ';' + newData.qualifiedInterval[0].context.text + ';' +
            (newData.qualifiedInterval[0].range.low ?
                newData.qualifiedInterval[1].range.low.value + ';' + newData.qualifiedInterval[1].range.low.unit + ';' +
                newData.qualifiedInterval[0].range.low.unit + ';' + newData.qualifiedInterval[0].range.low.value + ';' + 'minimum' :
                newData.qualifiedInterval[1].range.high.value + ';' + newData.qualifiedInterval[1].range.high.unit + ';' +
                newData.qualifiedInterval[0].range.high.unit + ';' + newData.qualifiedInterval[0].range.high.value + ';' + 'maximum')
    }];
}
